<script setup lang="ts">
  import type { Component } from 'vue';

  defineProps<{
    text: string;
    icon: Component;
    disabled?: boolean;
  }>();

  const emit = defineEmits<{
    (e: 'click'): void;
  }>();
</script>

<template>
  <button
    type="button"
    class="flex h-[42px] flex-1 items-center justify-center gap-2 rounded-lg bg-[var(--theme-secondary)] px-3 text-sm leading-tight font-medium whitespace-nowrap text-white disabled:opacity-50"
    :disabled="disabled"
    @click="emit('click')"
  >
    <component :is="icon" class="size-5 shrink-0 text-white" aria-hidden="true" />
    <span>{{ text }}</span>
  </button>
</template>
